(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("hlTU3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ca1fc30271ca302f$export$2e2bcd8739ae039; });
const $ca1fc30271ca302f$var$transitionLength = 300;
const $ca1fc30271ca302f$var$openModal = (modal)=>{
    modal.classList.add("--open");
    modal.classList.remove("--hidden");
};
const $ca1fc30271ca302f$var$closeModal = (modal)=>{
    modal.classList.remove("--open");
    setTimeout(()=>{
        modal.classList.add("--hidden");
    }, $ca1fc30271ca302f$var$transitionLength);
};
const $ca1fc30271ca302f$var$initTriggers = ()=>{
    const triggers = document.querySelectorAll("[data-modal-target]");
    triggers.forEach((trigger)=>{
        const modalTarget = document.getElementById(trigger.getAttribute("data-modal-target") ?? "");
        if (modalTarget === null) return;
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            $ca1fc30271ca302f$var$openModal(modalTarget);
        });
    });
};
const $ca1fc30271ca302f$var$initModals = ()=>{
    const modals = document.querySelectorAll(".c-modal");
    modals.forEach((modal)=>{
        const closeButtons = document.querySelectorAll(".c-modal__close");
        modal.style.setProperty("--transtion-length", `${$ca1fc30271ca302f$var$transitionLength}ms`);
        closeButtons.forEach((closeButton)=>{
            closeButton.addEventListener("click", (event)=>{
                event.preventDefault();
                $ca1fc30271ca302f$var$closeModal(modal);
            });
        });
        modal.addEventListener("click", (event)=>{
            if (modal == event.target) $ca1fc30271ca302f$var$closeModal(modal);
        });
    });
};
// In case needed reinitialize modals
// When something is re rendered
const $ca1fc30271ca302f$var$init = ()=>{
    $ca1fc30271ca302f$var$initTriggers();
    $ca1fc30271ca302f$var$initModals();
};
var $ca1fc30271ca302f$export$2e2bcd8739ae039 = $ca1fc30271ca302f$var$init;
$ca1fc30271ca302f$var$init();
document.addEventListener("modalsReinit", $ca1fc30271ca302f$var$init);

});

})();
//# sourceMappingURL=modal.df82949b.js.map
